import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { DataService } from '../services/data.service';
import { CommonService } from '../services/common.service';

@Injectable({
  providedIn: 'root'
})
export class ModuleGuard implements CanActivate {
  constructor(
    private dataService: DataService,
    private commonService: CommonService,
    private router: Router
  ) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let modules = route.data.modules as Array<string>;
    let sideMenus = this.dataService.getSidebarMenus();
    if (modules.some(module => sideMenus.includes(module))) {
      return true;
    } else {
      this.router.navigate(['/insight/dashboard']);
      this.commonService.setToastr(400, 'You do not have permission to access this menu. Please contact your administrator for assistance.');
      return false;
    }

  }

}
